module.exports = __webpack_public_path__ + "static/img/sprite.fed911e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-italia/dist/svg/sprite.svg
// module id = 16
// module chunks = 1